import { render, staticRenderFns } from "./ExtractVendor.vue?vue&type=template&id=52179725&"
import script from "./ExtractVendor.vue?vue&type=script&lang=ts&"
export * from "./ExtractVendor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports